<script>
    import { appManager } from "../AppManagerStore";
    import { _ } from "svelte-i18n";
</script>

<section
    id="testimonial"
    class="py-12 overlay overlay-black overlay-60 jarallax"
    style="background: url({$appManager.PublicUrl}img/photos/gent-fietser.jpg) no-repeat center center fixed;     -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-7">
                <span class="badge rounded-pill bg-primary-soft mb-3"
                    ><span class="h6 text-uppercase">{$_("communicate.testimonial.tag")}</span></span>
                <!-- Blockquote -->
                <blockquote class="blockquote mb-0">
                    <!-- Text -->
                    <p class="h2 text-white">
                        {$_("communicate.testimonial.part1")}
                    </p>
                    <p class="h2 text-white">
                        {$_("communicate.testimonial.part2")}
                    </p>

                    <!-- Footer -->
                    <footer class="blockquote-footer text-white-50 mb-0">
                        {$_("communicate.testimonial.footer1")}
                        <a href="https://www.billiebonkers.be/"
                            >Billie Bonkers</a>
                    </footer>
                </blockquote>
            </div>
        </div>
        <!-- / .row -->
    </div>
    <!-- / .container -->
</section>
